"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FullScreenWrapper = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var rotation =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("from{transform:rotate(0deg)}to{transform:rotate(270deg)}");
var dash =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("0%{transform:rotate(0deg);stroke-dashoffset:187;}50%{stroke-dashoffset:46.75;transform:rotate(135deg);}100%{stroke-dashoffset:187;transform:rotate(450deg);}");

var styles = function styles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("animation:", rotation, " 1.4s linear infinite;will-change:transform,stroke-dashoffset;circle{stroke-dasharray:187;transform-origin:center;stroke:", color.dark.amethyst, ";animation:", dash, " 1.4s ease-in-out infinite;will-change:transform;}")
  );
};

var FullScreenWrapper =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1gl7t7f0"
})("position:fixed;z-index:10;left:50%;top:50%;margin-top:-32.5px;margin-left:-32.5px;");
exports.FullScreenWrapper = FullScreenWrapper;

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("svg", {
  target: "css-1gl7t7f1"
})(styles));

exports.default = _default;